/**
 * The base URL of this site's own server (its /api routes): the dev API server's
 * port in development, else the marketplace root URL or the page's own origin.
 * Its own module so components that only need a link don't import the API calls.
 */
export const apiBaseUrl = marketplaceRootURL => {
  const port = process.env.REACT_APP_DEV_API_SERVER_PORT;
  const useDevApiServer = process.env.NODE_ENV === 'development' && !!port;

  // In development, the dev API server is running in a different port
  if (useDevApiServer) {
    return `${window.location.protocol}//${window.location.hostname}:${port}`;
  }

  // Otherwise, use the given marketplaceRootURL parameter or the same domain and port as the frontend
  // window is not available during SSR — fall back to the env var in that case
  return marketplaceRootURL
    ? marketplaceRootURL.replace(/\/$/, '')
    : typeof window !== 'undefined'
    ? `${window.location.origin}`
    : process.env.REACT_APP_MARKETPLACE_ROOT_URL || '';
};
